module.exports = __webpack_public_path__ + "static/media/interface.d7068532.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/interface.svg
// module id = 259
// module chunks = 0